"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenGrantType = exports.CustomerDisplayPermission = exports.Roles = exports.BackOfficeUIPermission = exports.POSAppUIPermission = exports.Auth0Roles = exports.AuthUserEventType = exports.AuthErrorCodes = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["USER"] = "USER";
    AccountType["ORG"] = "ORG";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AuthErrorCodes;
(function (AuthErrorCodes) {
    AuthErrorCodes["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AuthErrorCodes["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    AuthErrorCodes["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    AuthErrorCodes["REFRESH_TOKEN_EXPIRED"] = "REFRESH_TOKEN_EXPIRED";
    AuthErrorCodes["INVALID_TOKEN"] = "INVALID_TOKEN_OR_EXPIRED";
    AuthErrorCodes["INVALID_SCOPES"] = "INVALID_SCOPES";
})(AuthErrorCodes = exports.AuthErrorCodes || (exports.AuthErrorCodes = {}));
/**
 * User events used by lambda functions
 */
var AuthUserEventType;
(function (AuthUserEventType) {
    AuthUserEventType["CREATE_USER_AND_ASSIGN_ROLES"] = "CREATE_USER_AND_ASSIGN_ROLES";
    AuthUserEventType["DELETE_USER_AND_UNASSIGN_ROLES"] = "DELETE_USER_AND_UNASSIGN_ROLES";
    AuthUserEventType["ADD_ROLES_TO_USER"] = "ADD_ROLES_TO_USER";
    AuthUserEventType["DELETE_ROLES_FROM_USER"] = "DELETE_ROLES_FROM_USER";
    AuthUserEventType["UPDATE_USER"] = "UPDATE_USER";
    AuthUserEventType["CREATE_ROLES"] = "CREATE_ROLES";
    // add / modify / delete permissions for a given `n` role(s)
    AuthUserEventType["UPDATE_ROLES_PERMISSIONS"] = "UPDATE_ROLES_PERMISSIONS";
    // TODO: we might need ADD_PERMISSION_TO_USER, REMOVE_PERMISSION_TO_USER, in future
})(AuthUserEventType = exports.AuthUserEventType || (exports.AuthUserEventType = {}));
var Auth0Roles;
(function (Auth0Roles) {
    Auth0Roles["ADMIN"] = "ADMIN";
    Auth0Roles["MANAGER"] = "MANAGER";
    Auth0Roles["BILLING_STAFF"] = "BILLING_STAFF";
    Auth0Roles["SERVING_STAFF"] = "SERVING_STAFF";
    Auth0Roles["WAIT_STAFF"] = "WAIT_STAFF";
})(Auth0Roles = exports.Auth0Roles || (exports.Auth0Roles = {}));
// To be able to assign these permissions to any role these must be present with resource server.
// In future if we want this permissions restrictions on our API too we can use them
var POSAppUIPermission;
(function (POSAppUIPermission) {
    POSAppUIPermission["VIEW_REGISTER_CLOSURE"] = "VIEW_REGISTER_CLOSURE";
    POSAppUIPermission["PRINT_REGISTER_CLOSURE"] = "PRINT_REGISTER_CLOSURE";
    POSAppUIPermission["ACCESS_POS_APP_ONLY"] = "ACCESS_POS_APP_ONLY";
    POSAppUIPermission["APPLY_DISCOUNT"] = "APPLY_DISCOUNT";
    POSAppUIPermission["FINISH_SALE"] = "FINISH_SALE";
    POSAppUIPermission["MANAGE_MONEY_MOVEMENT"] = "MANAGE_MONEY_MOVEMENT";
    POSAppUIPermission["CREATE_ORDER"] = "CREATE_ORDER";
    POSAppUIPermission["MANAGE_OPEN_ORDER"] = "MANAGE_OPEN_ORDER";
    POSAppUIPermission["DECREASE_CART_ITEM_QTY"] = "DECREASE_CART_ITEM_QTY";
    POSAppUIPermission["VOID_ORDER"] = "VOID_ORDER";
    POSAppUIPermission["CANCEL_ORDER_ITEM"] = "CANCEL_ORDER_ITEM";
})(POSAppUIPermission = exports.POSAppUIPermission || (exports.POSAppUIPermission = {}));
var BackOfficeUIPermission;
(function (BackOfficeUIPermission) {
    BackOfficeUIPermission["ACCESS_BACKOFFICE_ONLY"] = "ACCESS_BACKOFFICE_ONLY";
})(BackOfficeUIPermission = exports.BackOfficeUIPermission || (exports.BackOfficeUIPermission = {}));
var Roles;
(function (Roles) {
    Roles["STORE_ADMIN"] = "Store Admin";
    Roles["VENUE_ADMIN"] = "Venue Admin";
    Roles["ORG_ADMIN"] = "Org Admin";
    Roles["MANAGER"] = "Manager";
    Roles["WAITER"] = "Waiter";
})(Roles = exports.Roles || (exports.Roles = {}));
var CustomerDisplayPermission;
(function (CustomerDisplayPermission) {
    CustomerDisplayPermission["CDS_REFRESH_TOKEN"] = "CDS_REFRESH_TOKEN";
})(CustomerDisplayPermission = exports.CustomerDisplayPermission || (exports.CustomerDisplayPermission = {}));
var TokenGrantType;
(function (TokenGrantType) {
    TokenGrantType["CLIENT_CREDENTIALS"] = "client-credentials";
})(TokenGrantType = exports.TokenGrantType || (exports.TokenGrantType = {}));
//# sourceMappingURL=auth.js.map